<template>
   <div class="content-wrapper pl-3 pr-3 pb-3 pt-3 mb-2" style="height: inherit; width:inherit;">
    <!-- Content Header (Page header) -->
        <div v-if="$gate.isSeller()">
<!-- Whatever VUE CONTENT: PLACE IT AFTER THIS COMMENT -->
            
    <section class="content-header">
        <div class="container-fluid">
          <div class="row mb-2">
            <div class="col-sm-6">
              <h2>Auction Report</h2>
            </div>
            <div class="col-sm-6">
              <ol class="breadcrumb float-sm-right">
                <li class="breadcrumb-item"><a href="/home">Home</a></li>
                <li class="breadcrumb-item active">{{ $route.meta.title }}</li>
              </ol>
            </div>
          </div>
          <button @click="generateReport" class="btn btn-secondary fa fa-print float-right"> Generate Report</button>
        </div><!-- /.container-fluid -->
        
      </section>

    <!-- Main content -->
    <vue-html2pdf
        :show-layout="false"
        :float-layout="true"
        :enable-download="true"
        :preview-modal="false"
        :paginate-elements-by-height="1400"
        filename="LotDetails"
        :pdf-quality="2"
        :manual-pagination="false"
        pdf-format="a4"
        pdf-orientation="landscape"
        pdf-content-width="95%"
 
        
        @hasStartedGeneration="hasStartedGeneration()"
        @hasGenerated="hasGenerated($event)"
        ref="html2Pdf"
    >
    	 <section slot="pdf-content" style="background-color: white;">
    	 		<br>
    			<div class="col-sm-12" style="margin-left: 0%">
    			<div class="row">
    				<div class="col-sm-6">
    						<h2>Auction #{{total.auction}} Report</h2>
    					</div>
    					<div class="col-sm-6">
       					<img class="float-right" src="http://35.247.177.36/images/logo/logo_nav.png" alt="CardamomAuction.com Logo" style="opacity: 1;">
       				</div>
    			</div>
    			<div class="card card-primary overflow-auto">
    			<div class="card-body overflow-auto">
    			<div class="row">
    			<table class="table table-striped overflow-auto">
    				<thead>
    					<tr>
      					<th scope="col">Lot Number</th>
      					<th scope="col">Seller Name</th>
      					<th scope="col">Net Weight</th>
      					<th scope="col">Gunny Bags</th>
      					<th scope="col">Status</th>
      					<th scope="col">Price/KG</th>
      					<th scope="col">Value</th>
      					<th scope="col">(-)less Discount 1%</th>
      					<th scope="col">Less Commission</th>
      					<th scope="col">Profile Mapping Fee</th>
      					<th scope="col">Total Include GST & Kerala Cess</th>
      					<th scope="col">Net Amount to Seller</th>
    					</tr>
  					</thead>
  					<tbody>
  						<tr v-for="lot in lots">
  							<td>{{lot.name}}</td>
  							<td>{{lot.seller_name}}</td>
  							<td>{{lot.net_weight}}</td>
  							<td>{{lot.gunny_bags}}</td>
  							<td>{{lot.status}}</td>
  							<td>{{lot.sold_price}}</td>
  							<td>{{lot.value}}</td>
  							<td>{{lot.discount}}</td>
  							<td>{{lot.commission}}</td>
  							<td>{{lot.profile_mapping}}</td>
  							<td>{{lot.total_include}}</td>
  							<td>{{lot.net_amount}}</td>
  						</tr>
  						<tr>
  							<th>Total</th>
  							<th></th>
  							<th>{{total.net_weight}}</th>
  							<th>{{total.gunny_bags}}</th>
  							<th></th>
  							<th></th>
  							<th>{{total.value}}</th>
  							<th>{{total.discount}}</th>
  							<th>{{total.commission}}</th>
  							<th>{{total.profile_mapping}}</th>
  							<th>{{total.total_include}}</th>
  							<th>{{total.net_amount}}</th>
  						</tr>
  					</tbody>
    			</table>
    			</div>
    			<br>
    			<div class="row">
    			<div class="col-sm-6">
					<div class="card card-primary card-outline">
    				<div class="card-header">
    					Seller Details
    				</div>
						<div class="card-body">
							<p><b>Name: </b>{{buyerForm.name}}</p>
							<p><b>Email: </b>{{buyerForm.email}}</p>
							<p><b>Phone: </b>{{buyerForm.mobile}}</p>
						</div>
					</div>
					</div>
					<p>{{date}}</p>
    			</div>
    			</div>
    		</div>
    		</div>
      </section>
    </vue-html2pdf>
    <section class="content">
    	<br>
    	<div class="col-sm-12">
    		
    			<div class="card card-primary card-outline">
    			<div class="card-body overflow-auto">
    			
    			<table class="table table-striped">
    				<thead>
    					<tr>
      					<th scope="col">Lot Number</th>
      					<th scope="col">Seller Name</th>
      					<th scope="col">Net Weight</th>
      					<th scope="col">Gunny Bags</th>
      					<th scope="col">Status</th>
      					<th scope="col">Price/KG</th>
      					<th scope="col">Value</th>
      					<th scope="col">(-)less Discount 1%</th>
      					<th scope="col">Less Commission</th>
      					<th scope="col">Profile Mapping Fee</th>
      					<th scope="col">Total Include GST & Kerala Cess</th>
      					<th scope="col">Net Amount to Seller</th>
    					</tr>
  					</thead>
  					<tbody>
  						<tr v-for="lot in lots">
  							<td>{{lot.name}}</td>
  							<td>{{lot.seller_name}}</td>
  							<td>{{lot.net_weight}}</td>
  							<td>{{lot.gunny_bags}}</td>
  							<td>{{lot.status}}</td>
  							<td>{{lot.sold_price}}</td>
  							<td>{{lot.value}}</td>
  							<td>{{lot.discount}}</td>
  							<td>{{lot.commission}}</td>
  							<td>{{lot.profile_mapping}}</td>
  							<td>{{lot.total_include}}</td>
  							<td>{{lot.net_amount}}</td>
  						</tr>
  						<tr>
  							<th>Total</th>
  							<th></th>
  							<th>{{total.net_weight}}</th>
  							<th>{{total.gunny_bags}}</th>
  							<th></th>
  							<th></th>
  							<th>{{total.value}}</th>
  							<th>{{total.discount}}</th>
  							<th>{{total.commission}}</th>
  							<th>{{total.profile_mapping}}</th>
  							<th>{{total.total_include}}</th>
  							<th>{{total.net_amount}}</th>
  						</tr>
  					</tbody>
    			</table>
    			<br>
    			<div class="row">
    			<div class="col-sm-6">
					<div class="card card-primary card-outline">
    				<div class="card-header">
    					Seller Details
    				</div>
						<div class="card-body">
							<p><b>Name: </b>{{buyerForm.name}}</p>
							<p><b>Email: </b>{{buyerForm.email}}</p>
							<p><b>Phone: </b>{{buyerForm.mobile}}</p>
						</div>
					</div>
					</div>
					
					
    			</div>
    			</div>
    			
    		</div>
    		</div>
    	
		</section>
    <!-- /.content -->

<br>
      <br>
    
<!-- All VUE Parts end before this comment -->
        </div>
        <div v-if="!$gate.isSeller()">
             <access-denied></access-denied>
        </div>
    </div>
</template>

<script>
		import VueHtml2pdf from 'vue-html2pdf'
    export default {
        mounted() {
            console.log('Component mounted.')
        },
        
        components: {
       	 	VueHtml2pdf
   			},
        
        created(){
        	this.getLotDetails();
        	this.getSellerDetails();
        },
        
        data(){
        	return {
        		lots: [],
        		total: [],
        		buyerForm: new Form({
        			name: '',
        			email: '',
        			mobile: ''
        		}),
        		
        		date: ''
        	}
        },
        
        methods: {
        	getLotDetails(){
        		axios.post("/api/getSellerAuctionReport", {user_id: this.$userId, auction_id: this.$route.params.id})
        		.then(response => {
        			this.lots = response.data.data;
        			this.total = response.data.total;
        		})
        	},
        	
        	generateReport () {
        		var currentdate = new Date(); 
        		this.date = "Generated on "+currentdate.getDate() + "/"
                + (currentdate.getMonth()+1)  + "/" 
                + currentdate.getFullYear() + " at "  
                + currentdate.getHours() + ":"  
                + currentdate.getMinutes() + ":" 
                + currentdate.getSeconds();
            this.$refs.html2Pdf.generatePdf()
        	},
        	
        	getSellerDetails(){
        		axios.post("/api/getUser", {id: this.$userId})
        		.then(response => {
        			this.buyerForm.fill(response.data);
        		})
        	}
        }
    }
</script>
